<template>
  <div class="content">
    <!-- <img style="width:100%;height:100%" class=""  src="../../assets/map.png" alt /> -->
    <div id="map_cn"></div>
  </div>
</template>
 
<script>
import "echarts/map/js/china.js";

export default {
  data() {
    return {
      domImg: require('@/assets/bg.jpg'),
      //地图中的数据
      dataList: [],
      //指定图表的配置项和数据
      option: {
        //标题组件
        title: {
          show: true,
          // text: "橘色盒子云数据中心",
          // subtext: "XX",
          left: "center",
          top: 16
        },
        //提示框组件
        tooltip: {
          show: true,
          //触发类型：数据项图形触发
          trigger: "item",
          padding: 20,
          position: ["10%", "75%"],
          borderWidth: 1,
          borderColor: "rgb(121,94,76)",
          backgroundColor: "rgba(63, 52, 95, 0.4)",
          textStyle: {
            color: "rgb(216,186,32)",
            fontSize: 12
          },
          //提示框内容格式器

          formatter: e => {
            console.log(e, "eeaaa");
            let deviceInfo = e.data;
            //字符串模板
            let context = `
               <div style="width:230px;height:150px;">
                   <p style="line-height: 30px; font-weight: 600;font-size:18px";>${deviceInfo.name==undefined?"加载中":deviceInfo.name}-${deviceInfo.address==undefined?"加载中":deviceInfo.address}</p>        
                    <p style="width:230px;height:1px;background:#DCDCDC	",></p>
                   <p style="line-height: 50px;font-size:16px;">${deviceInfo.title==undefined?"数据加载中":deviceInfo.title}</p>
                   <p><span style="line-height: 30px;font-size:16px">${deviceInfo.column1==undefined?"数据加载中":deviceInfo.column1}</span></p>
                   <p style="font-size:16px;line-height: 50px;width:200px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">${deviceInfo.column2==undefined?"用户扫码中":deviceInfo.column2}</p>
               </div>
            `;
            return context;
          }
        },
        //地理坐标系组件
       geo: [
          {
            // 主图
            map: "china",
            zlevel: 0,
            zoom: 1.2, //当前视角的缩放比例
            roam: false, //是否开启平游或缩放
            center: undefined,
            show: true,
            label: {
              normal: {
                show: true,
                textStyle:{color:"#ffffff"},//省份标签字体颜色
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderColor: "#fff",
                borderWidth: 1,
                areaColor:"rgba(20, 113, 255,0.6)",
                color:'#fff',
                
              },
              emphasis: {
                areaColor: "#f98333",
                color:'#fff',
                shadowOffsetX: -2,
                shadowOffsetY: 5,
                shadowBlur: 10,
              },
            },
          },
          //第一层投影
          {
                map: "china",
            zlevel: -1,
            zoom: 1.22, //当前视角的缩放比例
            roam: false, //是否开启平游或缩放
            center: undefined,
            show: true,
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderJoin: "round",
                borderColor: "rgba(176,228,252,1)",
                borderWidth: 3,
                areaColor: "rgba(133,188,232,1)",
                shadowColor: "rgba(133,188,232,.7)",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 25,
              },
              emphasis: {
                show: false,
              },
            },
          },
                  //第一层投影
                  {
                map: "china",
            zlevel: -1,
            zoom: 1.22, //当前视角的缩放比例
            roam: false, //是否开启平游或缩放
            center: undefined,
            show: true,
            label: {
              normal: {
                show: false,
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                borderJoin: "round",
                borderColor: "rgba(50,116,225,0.5)",
                borderWidth: 3,
                areaColor: "rgba(133,188,232,0.5)",
                shadowColor: "rgba(133,188,232,0.5)",
                shadowOffsetX: 0,
                shadowOffsetY: 0,
                shadowBlur: 25,
              },
              emphasis: {
                show: false,
              },
            },
          },
     
     


   ],

        series: [
          //地图
          {
            type: "map",
            map: "china",
            roam: false,
            geoIndex: 0,
            data: ""
          },
          //散点
          {
            type: "scatter", // 类型
            zlevel: 5,
            coordinateSystem: "geo", // 该系列使用的坐标系 可选: 'cartesian2d','polar','geo
            // 图形的样式
            symbolSize: "4",
            itemStyle: {
              normal: {
                show: true,
                color: "yellow"
              }
            },
            data: [
              {
                name: "深圳",
                value: [114.271522, 22.753644]
              },
              {
                name: "南京",
                value: [118.78, 32.04]
              },
              {
                name: "重庆",
                value: [106.54, 29.59]
              },
              {
                name: "北京",
                value: [116.24, 39.55, 100]
              },
              {
                name: "荆州",
                value: [113.41, 29.59]
              },
              {
                name: "山东",
                value: [117.1582, 36.8701]
              },
              {
                name: "乌鲁木齐",
                value: [87.617733, 43.792818]
              }
            ]
            // symbolSize: function(val) {
            //   return val[2] / 1500;
            //   mn;
            // }
          },
          // 点

          // 连接点的线
          {
            name: "线路",
            type: "lines",
            // 坐标采用经纬度
            coordinateSystem: "geo",

            large: true,
            zlevel: 10,
            effect: {
              show: true,
              color: "yellow",
              period: 4, //箭头指向速度，值越小速度越快
              trailLength: 0.1, //特效尾迹长度[0,1]值越大，尾迹越长重
              symbol: "diamond", //箭头图标
              symbolSize: 7 //图标大小
            },
            lineStyle: {
              normal: {
                color: "#0FD1D9",
                // 线条宽度
                width: 0.2,
                opacity: 1,
                curveness: 0.3
              }
            },
            label: {
              normal: {
                show: false,
                position: "middle",
                formatter: "{b}"
              }
            },
            data: []
          }
        ]
      },
      feiList: []
    };
  },
  computed: {
    feiData: function() {
      return this.$store.getters.getState("feiData");
    },

    timeData: function() {
      return this.$store.getters.getState("timeData");
    },
    sanData: function() {
      return this.$store.getters.getState("sanData");
    }
  },
  watch: {
    //飞线
    feiData: function(newVal, oldVal) {
      let feiData = this.$store.getters.getState("feiData");
      // console.log(feiData,">feiData>>>>>feiDatafeiDatafeiData", );
      let flays = [];
      for (let item of feiData) {
        flays.push({
          coords: [
            [item.formLng, item.formLat],
            [item.toLng, item.toLat]
          ]
        });
      }
      this.option.series[2].data = flays;
      this.myChart.setOption(this.option);
    },
    //散点
    sanData: function(newVal, oldVal) {
      let sanData = this.$store.getters.getState("sanData");
      let sanS = [];
      for (let item of sanData) {
        sanS.push({
          value: [item.lng, item.lat]
        });
      }
      this.option.series[1].data = sanS;
      console.log(sanS, "sanS散点");
      this.myChart.setOption(this.option);
    },
    //实时订单
    timeData: function(newVal, oldVal) {
      let timeData = this.$store.getters.getState("timeData");
      console.log(timeData, ">timeData>>>>>timeData实时订单");
      this.option.series[0].data = timeData;
      this.myChart.setOption(this.option);
    }
  },
  methods: {
    //定义方法 draw_map 绘制中国地图
    draw_map() {

      this.myChart = this.$echarts.init(document.getElementById("map_cn"));
      //高亮轮播展示
      var hourIndex = 0;
      var carouselTime = null;
      //setInterval() 可在每隔指定的毫秒数循环调用函数或表达式,直到clearInterval把它清除

      //使用setInterval方法后,必须使用箭头函数而不能写function,否则后续在该方法中无法调用data中的数据
      //carouselTime =setInterval(function(){ //错误写法

      carouselTime = setInterval(() => {
        //dispatchAction echarts的API：触发图表行为
        this.myChart.dispatchAction({
          type: "downplay", //downplay 取消高亮指定的数据图形
          seriesIndex: 0
        });
        this.myChart.dispatchAction({
          type: "highlight", //highLight 高亮指定的数据图形
          seriesIndex: 0, //系列index
          dataIndex: hourIndex //数据index
        });
        this.myChart.dispatchAction({
          type: "showTip", //showTip 显示提示框
          seriesIndex: 0,
          dataIndex: hourIndex
        });
        // hourIndex++;
        // console.log(this.dataList.length,"this.dataList.length)===============>")
        // console.log(hourIndex,"hourIndex)===============>")
        //当循环到数组当中的最后一条数据后，重新进行循环
        // if (hourIndex > this.dataList.length) {
        //   hourIndex = 0;
        // }
      }, 3000);

      //显示地图
      this.myChart.setOption(this.option);
      window.addEventListener("resize", () => {
        if (this.myChart) {
          this.myChart.resize();
        }
      });
    },
    //修改echart配制
    setEchartOption() {
      var domImg = document.createElement("img");
domImg.style.height = domImg.height = domImg.width = domImg.style.width = "100px";
domImg.src = this.domImg;
      // this.options.geo[0].itemStyle.areaColor.image = this.img
      //实时订单
      this.option.series[0].data = this.dataList;
      //飞线
      this.option.series[2].data = [
        {
          coords: [
            [106.54, 29.59],
            [117.1582, 36.8701]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [116.24, 39.55, 100]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [118.78, 32.04]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [113.41, 29.59]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [114.271522, 22.753644]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [117.36606, 25.96226]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [100.233154, 26.897228]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [106.634475, 29.737187]
          ]
        },
        {
          coords: [
            [106.54, 29.59],
            [104.848015, 26.584398]
          ]
        }
      ];
    }
  },
  created() {
    // this.setEchartOption();
  },
  mounted() {
    this.$nextTick(() => {
      this.draw_map();
    });
  }
};
</script>
 
<style scoped>
.content {
  width: 100%;
  height: 75%;
  /* background-image: radial-gradient( 100% 50% at 50% 50%, #41adff 0%, transparent 60%, transparent 100% ); */
  margin-top: -4%;
  /* background-image:url(../../assets/map.png) */
  
}
#map_cn {
  width: 100%;
  height: 100%;
  margin-top: 20px;

  /* margin: auto; */
  /* position: absolute;
  top: 10%; */


}
</style>


// WEBPACK FOOTER //
// src/views/moudles/MapMoudle.vue